export class SetProgress {
  public static readonly type = '[Progress] Set progress';
  public constructor(public current: number, public total: number) {}
}

export class ResetProgress {
  public static readonly type = '[Progress] Reset progress';
}
